"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currencyToNumber = currencyToNumber;
exports.currencyToNumberString = currencyToNumberString;
exports.currencyToNumberStringByCountry = currencyToNumberStringByCountry;
exports.getCurrencyPrecision = getCurrencyPrecision;
exports.getCurrencyPrecisionByCountry = getCurrencyPrecisionByCountry;
exports.getCurrencyTypeByCountry = getCurrencyTypeByCountry;
exports.numberToCurrency = numberToCurrency;
exports.numberToCurrencyByCountry = numberToCurrencyByCountry;

var _base = require("./base");

function numberToCurrency(numberParam, isHighlight) {
  var result = (0, _base.getCurrencyByPattern)(numberParam / 100);

  var _getNumberV = (0, _base.getNumberV2)(),
      decimal = _getNumberV.decimal,
      group = _getNumberV.group;

  if (group) result = result.replace(',', group);
  if (decimal) result = result.replace(/\.(\d{2})$/, "".concat(decimal, "$1"));
  if (isHighlight) result = result.replace(new RegExp("(\\d+[\\".concat(decimal || ".", "\\").concat(group || ",", "\\d]+\\d+)")), '{$1}');
  return result.replace("¤", "ج.م.");
}

function currencyToNumberString(currency) {
  var _getNumberV2 = (0, _base.getNumberV2)(),
      decimal = _getNumberV2.decimal,
      group = _getNumberV2.group;

  var numberMatch = currency.match(new RegExp("\\d[\\".concat(decimal || ".", "\\").concat(group || ",", "\\d]*\\d")));
  return (/-/.test(currency) ? "-" : "") + (numberMatch ? numberMatch.join("") : "0");
} // 弃用


function currencyToNumber(currency) {
  if (!/[0-9]/.test(currency)) return currency;

  var _getNumberV3 = (0, _base.getNumberV2)(),
      _getNumberV3$decimal = _getNumberV3.decimal,
      decimal = _getNumberV3$decimal === void 0 ? '.' : _getNumberV3$decimal;

  var decimalStr = currency.match(new RegExp("\\".concat(decimal || '.', "\\d+")));
  var decimalLen = decimalStr ? decimalStr[0].length - 1 : 0;
  var number = currency.match(/[-0-9]/g).join("") - 0;

  if (getCurrencyPrecision()) {
    var denominator = getCurrencyPrecision() - 1;

    while (decimalLen > 0) {
      denominator *= 10;
      decimalLen--;
    }

    number = number / denominator;
  }

  return number;
}

function getCurrencyTypeByCountry(country) {
  return _base.currencyMap[country];
} // 获取货币精度


function getCurrencyPrecision() {
  return (0, _base.getNumberV2)().precision.currency;
} // 根据用户传入的国家码获取货币精度


function getCurrencyPrecisionByCountry(country) {
  if (!country) {
    throw Error("Elvish Error: please call getCurrencyPrecisionByCountry function with country parameter first");
  }

  return (0, _base.getNumberV2ByCountry)(country).precision.currency;
} // 根据用户传入的国家码进行数字转货币


function numberToCurrencyByCountry(numberParam, country, locale, isHighlight) {
  if (!country || typeof country !== 'string') {
    throw Error("Elvish Error: please call numberToCurrencyByCountry function with country parameter first");
  }

  if (!locale || typeof locale !== 'string') {
    throw Error("Elvish Error: please call numberToCurrencyByCountry function with locale parameter first");
  }

  var result = (0, _base.getCurrencyByPatternByCountry)(numberParam / 100, country, locale.replace('_', '-'));

  var _getNumberV2ByLocale = (0, _base.getNumberV2ByLocale)(locale.replace('_', '-')),
      decimal = _getNumberV2ByLocale.decimal,
      group = _getNumberV2ByLocale.group;

  if (group) result = result.replace(',', group);
  if (decimal) result = result.replace(/\.(\d{2})$/, "".concat(decimal, "$1"));
  if (isHighlight && typeof isHighlight === 'boolean') result = result.replace(new RegExp("(\\d+[\\".concat(decimal || ".", "\\").concat(group || ",", "\\d]+\\d+)")), '{$1}');
  return result.replace("¤", "ج.م.");
} // 根据用户传入的国家码进行货币转数字字符串


function currencyToNumberStringByCountry(currency, locale) {
  if (!locale) {
    throw Error("Elvish Error: please call currencyToNumberStringByCountry function with locale parameter first");
  }

  var _getNumberV2ByLocale2 = (0, _base.getNumberV2ByLocale)(locale.replace('_', '-')),
      decimal = _getNumberV2ByLocale2.decimal,
      group = _getNumberV2ByLocale2.group;

  var numberMatch = currency.match(new RegExp("\\d[\\".concat(decimal || ".", "\\").concat(group || ",", "\\d]*\\d")));
  return (/-/.test(currency) ? "-" : "") + (numberMatch ? numberMatch.join("") : "0");
}